<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { computed } from 'vue';
import generateId from '@/utils/generateId.ts';
import { cn } from '@/utils/shadcn/lib/utils.ts';
import { AccordionContent, AccordionItem, AccordionTrigger } from './internal';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = withDefaults(defineProps<{
    class?: HTMLAttributes['class']
    value?: string
    label?: string
}>(), {
    class: '',
    value: '',
    label: '',
});

const modelValue = defineModel<string | string[]>('modelValue');

const value = computed(() => props.value || generateId('accordion-item-'));
</script>

<template>
    <AccordionItem
        v-model="modelValue"
        :value="value"
        :unmount-on-hide="false"
        collapsible
        :class="cn('border border-transparent border-b-input-dark has-[:focus-visible]:border-ring/50! has-[:focus-visible]:rounded-md', props.class)"
    >
        <AccordionTrigger
            data-slot="accordion-trigger"
            class="text-base font-semibold text-foreground px-2"
        >
            <span class="flex min-w-0 flex-wrap items-center gap-2.5">
                <slot name="label">
                    {{ props.label }}
                </slot>
                <slot name="badge"></slot>
            </span>
        </AccordionTrigger>
        <AccordionContent
            data-slot="accordion-content"
            class="text-base px-2"
        >
            <slot></slot>
        </AccordionContent>
    </AccordionItem>
</template>
